export default __webpack_public_path__ + "images/student/avatars/Hoppy-7ac66abc7d445e0d350506291909ede9.png";